import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import MyMatchingProfile from 'components/containers/matching/list/MyMatchingProfile';
import MatchingRoomList from 'components/containers/matching/list/MatchingRoomList';
import MatchingRoomListItem from 'components/presenters/matching/list/MatchingRoomListItem';
import JoinedMatchingRoomList from 'components/containers/matching/list/JoinedMatchingRoomList';
import TitleHeader from 'components/presenters/header/TitleHeader';
import server from 'server/serverController2';
import qs from 'qs';

export default function MatchingMainLayout() { 
  const history = useHistory();
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });

  const userPermission = useSelector((state) => {
    return state.userPermission;
  });


  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [lastPosNo, setLastPosNo] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [newAlarmExist, setNewAlarmExist] = useState(false);

  const handleScroll = (e)=>{
    const bottom = e.target.scrollHeight - e.target.scrollTop - 200 <= e.target.clientHeight;
    if(bottom) {
      loadRoomList();
    }
  }


  const loadRoomList = () => {
    if(!isLoading && !isEnd)
    {
      setIsLoading(true);
      let queryString = qs.stringify({order_by: "no", order: "desc", last_pos_no: lastPosNo})
      server.getRequestData(`matching/rooms?${queryString}`, (res)=>{
        if(res.success === 0)
        {
          return ;
        }
        let jsonData = res.data;
        let rooms = jsonData['rooms'];

        if(rooms.length > 0)
        {
          const lastRoom = rooms[rooms.length - 1];
          setLastPosNo(lastRoom['no'])
        }
        else
        {
          setIsEnd(true);
        }
        setIsLoading(false);
        setRoomList([...roomList, ...rooms]);
      })
    }
  }

  const unreadCheckCallback = (res) => {
    try
    {
      if(res['success'] !== 1)
      {
        return;
      }
      const unreadMsgCount = parseInt(res['data']['count']);
      if(unreadMsgCount > 0)
      {
        setNewAlarmExist(true);
      }
      else
      {
        setNewAlarmExist(false);
      }
    }
    catch(error)
    {
      console.log(error);
    }
  }
 
  const [profileInfo, setProfileInfo] = useState(null);
  const [recommendRoomInfo, setRecommendRoomInfo] = useState(null);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(()=>{
    loadRoomList();
    server.getRequestData('matching/profile',(res)=>{
      if(res.success === 0)
      {
        const errData = res['error']['res_data'];
        if(errData['detail_code'] === 'MATCHING_PROFILE_DOES_NOT_EXIST')
        { 
          if(userPermission['matching'] === false)
          {
            history.replace('/tutorial/matching');
          }
          else
          {
            history.replace('/matching/survey');  
          }
        }
        else
        {
          history.replace('/');
        }
        return ;
      }
      let profileInfo = res['data'];
      setProfileInfo(profileInfo);
    });

    server.getRequestData('users/matching',(res)=>{
      if(res.success === 0)
      {
        return ;
      }
      let jsonData = res.data;
      if(jsonData?.no)
      {
        setRecommendRoomInfo(jsonData);  
      }
    });

    if(userInfo['isLogin'])
    {
      server.getRequestData(`notifications/unread`, unreadCheckCallback)
    }
  },[])

  if(userInfo['isLogin'] === false)
  {
    history.replace('/social');
  }
  return (<>
    {
      (![null, undefined].includes(profileInfo))
      ?(<MainLayout>
        <HeaderSection style={{}}>
          <TitleHeader onBackBtn={null} newAlarmExist={newAlarmExist} isNotiBtn={true}/>
        </HeaderSection>
        <BodySection onScroll={handleScroll}>
          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(22/375))'}}>
            <ProfileTitleTxt>나와 같이할 친구 구해요</ProfileTitleTxt><ProfileBetaTxt>Beta</ProfileBetaTxt>
          </div>
          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(60/375))'}}>
            <MyMatchingProfile profileInfo={profileInfo}/>
          </div>
          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(20/375))'}}>
            <ProfileTitleTxt>대화방</ProfileTitleTxt>
          </div>

          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(22/375))'}}>
            <JoinedMatchingRoomList />
          </div>

          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(22/375))'}}>
            <ProfileTitleTxt>{userInfo['name']}님과 가장 잘맞는 친구추천</ProfileTitleTxt>
          </div>
          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(40/375))'}}>
            {
              (recommendRoomInfo)
              ?(<MatchingRoomListItem type={`recommend`} roomInfo={recommendRoomInfo}/>)
              :(<NoRecommandInfo>업데이트되는 대로 추천해드릴게요!</NoRecommandInfo>)
            }
          </div>

          <div style={{padding : '0 calc(100vw*(17/375))', marginBottom : 'calc(100vw*(22/375))'}}>
            <ProfileTitleTxt>실시간 친구 구하는 글 </ProfileTitleTxt>
          </div>
          <div style={{padding : '0 calc(100vw*(17/375))'}}>
            <MatchingRoomList roomList={roomList} setRoomList={setRoomList}/>
          </div>
        </BodySection>
      </MainLayout>)
      :(null)
    }
    </>
  );
}
//{//}
const MainLayout = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const HeaderSection = styled.div`
  min-height: calc(100vw*(51/375));
  height: calc(100vw*(51/375));
  flex: 0 1 auto;
`;

const BodySection = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
`;

const ProfileTitleTxt = styled.span`
font-weight: bold;
font-size: calc(100vw * (20 / 375));
line-height: calc(100vw * (29 / 375));
color: #121212;
margin-right: calc(100vw * (3 / 375));
`;
const ProfileBetaTxt = styled.span`
font-size: calc(100vw * (12 / 375));
line-height: calc(100vw * (14 / 375));
color: #707070;
`;
const NoRecommandInfo = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #E1981B;


  background: #FFF4D8;
  border-radius: 8px;
  text-align: center;
  padding: calc(100vw * (16 / 375)) 0;
`;